// extracted by mini-css-extract-plugin
module.exports = {"iconColor":"var(--gray-3)","socials":"Socials_socials__Snahq","socialName":"Socials_socialName__111Qy"};